import { render, staticRenderFns } from "./orireport.vue?vue&type=template&id=625da082&scoped=true&"
import script from "./orireport.vue?vue&type=script&lang=js&"
export * from "./orireport.vue?vue&type=script&lang=js&"
import style0 from "./orireport.vue?vue&type=style&index=0&id=625da082&prod&lang=css&"
import style1 from "./orireport.vue?vue&type=style&index=1&id=625da082&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "625da082",
  null
  
)

export default component.exports